import { render, staticRenderFns } from "./FaqsAddNew.vue?vue&type=template&id=583d1ef2&scoped=true&"
import script from "./FaqsAddNew.vue?vue&type=script&lang=js&"
export * from "./FaqsAddNew.vue?vue&type=script&lang=js&"
import style0 from "./FaqsAddNew.vue?vue&type=style&index=0&id=583d1ef2&prod&lang=scss&"
import style1 from "./FaqsAddNew.vue?vue&type=style&index=1&id=583d1ef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d1ef2",
  null
  
)

export default component.exports